/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Agent_Marketing_NameInputs */

const en_mk_mock_agent_marketing_name = /** @type {(inputs: Mk_Mock_Agent_Marketing_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kira`)
};

const id_mk_mock_agent_marketing_name = /** @type {(inputs: Mk_Mock_Agent_Marketing_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kira`)
};

/**
* | output |
* | --- |
* | "Kira" |
*
* @param {Mk_Mock_Agent_Marketing_NameInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_agent_marketing_name = /** @type {((inputs?: Mk_Mock_Agent_Marketing_NameInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Agent_Marketing_NameInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_agent_marketing_name(inputs)
	return en_mk_mock_agent_marketing_name(inputs)
});